import { Grid } from '@mui/material';
import { useCompanyRelativePath } from 'ogp/hooks';
import { ServiceAgreementsResponse } from 'ogp/services/service-agreements.types';
import { useTranslation } from 'react-i18next';
import { BlockLink, LwBlock } from 'redesign';
import { routes } from 'Routes';

export const ServiceAgreementBlock = ({
  serviceAgreement,
}: {
  serviceAgreement: ServiceAgreementsResponse[number];
}) => {
  const { t } = useTranslation(['ogp-screen-specific', 'all-platforms-common']);
  const generatePath = useCompanyRelativePath();

  let oppositePartyName: string;
  let roleLabel: string;
  let subtitle: string;
  switch (serviceAgreement.serviceAgreementPartyRole) {
    case 'LENDER':
      oppositePartyName = serviceAgreement.borrowerServiceAgreementParty.name;
      roleLabel = t('service-agreement.lender', { ns: 'all-platforms-common' });
      subtitle = t('collegial_lending_page.service-agreement.subtitle-to', {
        partyName: oppositePartyName,
        ns: 'ogp-screen-specific',
      });
      break;
    case 'BORROWER':
      oppositePartyName = serviceAgreement.lenderServiceAgreementParty.name;
      roleLabel = t('service-agreement.borrower', { ns: 'all-platforms-common' });
      subtitle = t('collegial_lending_page.service-agreement.subtitle-from', {
        partyName: oppositePartyName,
        ns: 'ogp-screen-specific',
      });
      break;
  }

  const dataBlocks = [
    {
      label: t('collegial_lending_page.service-agreement.role', { ns: 'ogp-screen-specific' }),
      value: roleLabel,
      format: 'string',
    } as const,
    {
      label: t('collegial_lending_page.service-agreement.distribution', {
        ns: 'ogp-screen-specific',
      }),
      value: oppositePartyName,
      format: 'string',
    } as const,
    {
      label: t('collegial_lending_page.service-agreement.start_date', {
        ns: 'ogp-screen-specific',
      }),
      value: serviceAgreement.createdAt,
      format: 'date',
    } as const,
  ];

  return (
    <Grid item xs={6} md={4} lg={3} key={serviceAgreement.id}>
      <BlockLink to={generatePath(routes.CollegialLending, { id: serviceAgreement.id })}>
        <LwBlock
          severity="none"
          id={serviceAgreement.id}
          title={t('collegial_lending_page.service-agreement.title', { ns: 'ogp-screen-specific' })}
          subtitle={subtitle}
          dataBlocks={dataBlocks}
        />
      </BlockLink>
    </Grid>
  );
};
